(function($) {
	
	var $question = $('.wp-block-metropolis-faq .question');
			
	$question.on('click', function(e) {
		
		if( $(e.target).closest('.answer').length ) return;
		
		var $answer = jQuery(this).children('.answer');
		$answer.stop().slideFadeToggle(250, function() {
			$(this).closest('.question').removeClass('is-closed');
		}).closest('.question').toggleClass(function(){
			return $(this).is('.is-open') ? 'is-open is-closed' : 'is-open';
		});
		
	});
	
})(jQuery);